var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.96289,
    width: 156,
    height: 155,
    rx: 73,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.518 53.9761H52.482C50.4225 53.9761 48.7471 55.6515 48.7471 57.711V106.265C48.7471 108.325 50.4225 110 52.482 110H105.518C107.578 110 109.253 108.325 109.253 106.265V57.7111C109.253 55.6516 107.578 53.9761 105.518 53.9761ZM104.771 105.518H53.229V58.458H104.771V105.518H104.771Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.012 68.9155H50.9878V73.3974H107.012V68.9155Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4338 48C63.1961 48 62.1929 49.0033 62.1929 50.241V62.1928C62.1929 63.4305 63.1961 64.4338 64.4338 64.4338C65.6715 64.4338 66.6748 63.4305 66.6748 62.1928V50.241C66.6748 49.0033 65.6715 48 64.4338 48Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3132 48C93.0755 48 92.0723 49.0033 92.0723 50.241V62.1928C92.0723 63.4305 93.0755 64.4338 94.3132 64.4338C95.5509 64.4338 96.5542 63.4305 96.5542 62.1928V50.241C96.5542 49.0033 95.5509 48 94.3132 48Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5902 92.8193H71.1565C69.9188 92.8193 68.9155 93.8226 68.9155 95.0603C68.9155 96.298 69.9188 97.3013 71.1565 97.3013H87.5902C88.8279 97.3013 89.8312 96.298 89.8312 95.0603C89.8312 93.8226 88.8279 92.8193 87.5902 92.8193Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5902 82.3613H71.1565C69.9188 82.3613 68.9155 83.3646 68.9155 84.6023C68.9155 85.84 69.9188 86.8433 71.1565 86.8433H87.5902C88.8279 86.8433 89.8312 85.8401 89.8312 84.6023C89.8312 83.3645 88.8279 82.3613 87.5902 82.3613Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar2.4ff0f439d51bdd47488a9fcf49b85074.svg";
export { ForwardRef as ReactComponent };